/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import { format } from "date-fns/esm";

export default function Lookup({
  controlNo,
  name,
  value,
  dataSet,
  dataValue,
  displayValue,
  items,
  values,
  setParameter,
}) {
  const [data, setData] = useState([{ text: items[0], value: values[0] }]);
  const [selectedValue, setSelectedValue] = useState(data.length > 0 ? data[0] : { text: items[0], value: values[0] });

  function getDefaultValue(dataArray) {
    let dt = dataArray;
    if (Number.isInteger(value)) {
      let index = +value;
      index = index >= dt.length ? dt.length - 1 : index;
      index = index < 0 ? 0 : index;
      return dt[index];
    } else {
      switch (value.toLowerCase()) {
        case "first":
          return dt[0];
        case "last":
          return dt[dt.length - 1];
        case "thismonth":
          let thismonth = format(new Date(), "yyyy-MM");
          let findIndexM = dt.findIndex((i) => i.value === thismonth);
          return dt[findIndexM];
        case "thisyear":
          let thisyear = format(new Date(), "yyyy");
          let findIndexY = dt.findIndex((i) => i.value === thisyear);
          return dt[findIndexY];
        default:
          return dt[0];
      }
    }
  }

  function checkNewData(newData) {
    if (newData.length !== 0) {
      const item = getDefaultValue(newData);
      setSelectedValue(item);
      setParameter(controlNo, name, item.value);
    } else setParameter(controlNo, name, "");
  }

  useEffect(() => {
    const newData = [];

    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        newData.push({
          text: items[i].toString(),
          value: values[i].toString(),
        });
      }
    } else {
      if (dataSet.data) {
        dataSet.data.forEach((element) => {
          newData.push({
            text: element[`${displayValue}`]?.toString(),
            value: element[`${dataValue}`]?.toString(),
          });
        });
      }
    }

    setData(newData);
    checkNewData(newData);
  }, [items]);

  return (
    <Autocomplete
      //ref = {(e)=> refKey.current[refId] = e}
      id={name}
      name={name}
      disableClearable
      options={data}
      getOptionLabel={(option) => option?.text ?? ""}
      renderInput={(params) => (
        <TextField
          //inputRef={(element) => (refKey.current[refId] = element)}
          //name={name}
          {...params}
          label=""
          margin="normal"
          fullWidth
        />
      )}
      value={selectedValue}
      onChange={(e, newValue) => {
        e.preventDefault();
        setSelectedValue(newValue);
        setParameter(controlNo, name, newValue.value);
      }}
    />
  );
}
